<ng-container>
  <div class="wrapper wrapper-content ng-scope animated fadeInRight">
    <div class="container-fluid  p-0">
      <div class="row">
        <div class="col-12">
          <span class="m-xst float-right m-l-md leyenda" *ngIf="models"> {{ 'General.search.showing' | translate }} {{
            filteredModels.length }} {{ 'General.search.showing1' | translate }} {{ models.length }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <input pInputText class="p-inputtext" type="text"
            placeholder="{{ 'General.search.maxLength' | translate:{maxLength: this.MIN_SEARCH_TEXT_LENGHT} }}"
            name="filterText" id="filterTextInput" [(ngModel)]="filterText" (ngModelChange)="updateFilter()"
            autocomplete="off" #searchField tabindex="1" />
        </div>
      </div>
      <ng-container *ngIf="models && models.length > 0; else noModels">
        <div class="row m-t-sm" *ngIf="isLoaded()">
          <div class="col-12">
            <p-table [value]="filteredModels" [columns]="columns" sortOrder="1" class="footer-over-pagination"
              [scrollable]="false" class="footer-over-pagination" [paginator]="false" [responsive]="true">
              <ng-template pTemplate="header">
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [style.width]="col.width"> {{col.header
                    | translate }} <p-sortIcon [field]="col.field"></p-sortIcon>
                  </th>
                  <th [style.width]="'10%'"></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-modelo let-columns="columns">
                <tr>
                  <td *ngFor="let col of columns">
                    <span class="p-column-title">{{ col.header | translate }}</span> {{modelo[col.field] | translate}}
                  </td>
                  <td>
                    <div class="d-flex justify-content-end">
                      <div class="btn-group">
                        <button class="btn btn-sm btn-primary t-action-button" aria-expanded="false"
                          [routerLink]="['/dossierCreation', modelo.identifier]" *ngIf="!isModelPublished(modelo)">
                          <i class="fas fa-plus" aria-hidden="true"></i>
                        </button>
                        <button class="btn btn-sm btn-primary t-action-button" aria-expanded="false"
                          [routerLink]="['/tenderDefinition', modelo.identifier]" *ngIf="!isModelPublished(modelo)">
                          <i class="fa fa-tasks" aria-hidden="true"></i>
                        </button>
                        <button class="btn btn-sm btn-primary t-action-button" (click)="deleteModel(modelo)"
                          aria-expanded="false" *ngIf="!isModelPublished(modelo)">
                          <i class="fas fa-times" aria-hidden="true"></i>
                        </button>
                        <button class="btn btn-sm btn-primary t-action-button" aria-expanded="false"
                          (click)="publishModel(modelo)" *ngIf="!isModelPublished(modelo)">
                          <i class="fas fa-cloud-upload-alt" aria-hidden="true"></i>
                        </button>
                        <button class="btn btn-sm btn-primary t-action-button" aria-expanded="false"
                          (click)="unpublishModel(modelo)" *ngIf="isModelPublished(modelo)">
                          <i class="fas fa-cloud-download-alt" aria-hidden="true"></i>
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr class="text-center">
                  <td colspan="5"> {{ 'General.noFilteredData' | translate }} </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
        <!-- DATOS -->
      </ng-container>
    </div>
  </div>
</ng-container>
<ng-template #noModels>
  <div class="alert alert-danger m-b-xs text-ellipsis col-12 ng-star-inserted m-t-sm" role="alert"><span>
      <i aria-hidden="true" class="fas fa-1-5x fa-exclamation-circle m-r-md"></i>{{ 'ProcurementProject.models.noModels'
      | translate }}</span>
  </div>
</ng-template>
<p-dialog header="{{ 'ProcurementProject.models.selectType' | translate }}" [(visible)]="popupModelTypesVisible"
  [responsive]="false" showEffect="fade" [modal]="true" [resizable]="false" [closable]="true" [dismissableMask]="true"
  [closeOnEscape]="false" [blockScroll]="true" [style]="{'width':'60vw'}"
  [contentStyle]="{ 'max-height': '80vh', overflow: 'hidden'}">
  <sub-header [isModal]="true" [windowHash]=this.windowHash [includeContextHelp]="true" *ngIf="true">
  </sub-header>
  <p-scrollPanel [style]="{width: '100%', height: '60vh'}" styleClass="custombar1">
    <div class="wrapper wrapper-content">
      <div class="container-fluid">
        <div class="row">
          <div class=" alert alert-info col-12" role="alert">
            <i class="fas fa-lg fa-info-circle m-r-lg"></i> {{ 'ProcurementProject.models.selectTypeInfo' | translate }}
          </div>
        </div>
        <div class="row">
          <div class="col-12  m-t-lg" *ngIf="definitions && definitions.length > 0">
            <p-table [value]="definitions" sortField="name" sortOrder="1" [rows]="20" [paginator]="false"
              [pageLinks]="4" [rowsPerPageOptions]="[15, 30, 100]"
              class="footer-over-pagination  mb-3 table table-striped table-hover ">
              <ng-template pTemplate="header">
                <tr class="ui-widget-header m-t-md">
                  <th class="p-md">
                    <strong> {{ 'ProcurementProject.models.selectTHeader' | translate }}</strong>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-def>
                <tr>
                  <td>
                    <span style="line-height: 2em;"><i class="fa fa-clone fa-lg m-r-lg"></i><strong>{{ def.name |
                        translate }}
                      </strong>{{ def.description | translate }} </span> <button
                      class="btn btn-sm btn-primary t-action-button float-right" aria-expanded="false"
                      (click)="createModel(def)">
                      <i class="fas fa-plus" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </p-scrollPanel>
</p-dialog>